import { isNil } from 'es-toolkit/compat';

export function capitalize(val: unknown): string {
    if (typeof val !== 'string') {
        return '';
    }

    return val.charAt(0).toUpperCase() + val.substring(1).toLowerCase();
}

export function capitalizeOptional(val: string | undefined): string | undefined {
    if (val === undefined) {
        return val;
    }

    return capitalize(val);
}

export function trimAndRemoveSpaces(input: unknown): string | null {
    if (isNil(input)) {
        return null;
    }

    if (typeof input !== 'string') {
        throw new TypeError('trimAndRemoveSpaces: input must be a string');
    }

    return input.trim().replace(/\s+/g, '');
}
